import DataTable, { Column } from "../../components/DataTable";
import { FiChevronDown } from "react-icons/fi";
import { QueryItem } from "../../types/Query";
import { useNavigate } from "react-router-dom";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import { useState } from "react";
import Tag from "../../components/Tags";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import AssignEnquiryModal from "../../components/modal/AssignEnquiryModel";

interface Props {
  data: QueryItem[];
  loading: boolean;
  onRefresh: () => void;
}

export default function QueriesList({ data, loading,onRefresh }: Props) {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState<QueryItem | null>(null);
  const [showAssign, setShowAssign] = useState(false);
  const [selectedQueryForAssign, setSelectedQueryForAssign] =
    useState<QueryItem | null>(null);

  const columns: Column<QueryItem>[] = [
    {
      label: "SL NO",
      accessor: "id",
      render: (_, index) => <span>{index + 1}</span>,
    },
    {
      label: "profile",
      accessor: "studentName",
      render: (item) => (
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-600 text-white font-semibold">
          {item.studentName.charAt(0).toUpperCase()}
        </div>
      ),
    },
    {
      label: "Student’s Name",
      accessor: "tudentName",
      searchable: true,
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item.studentName || "----"}
        </div>
      ),
    },
    {
      label: "DOB",
      accessor: "date",
      render: (item) => (
        <div className="text-[13px]">
          <div className="">{item.dateOfBirth}</div>
          <span>{item.placeOfBirth || "----"}</span>
        </div>
      ),
    },
    {
      label: "Parent Details",
      accessor: "",
      searchable: true,
      render: (item) => (
        <div className="text-start text-[13px]">
          <div className="text-neutral-400 text-nowrap">
            <span className="font-semibold">Mother : </span>{" "}
            {item.motherEmail || "---"}
          </div>
          <div className=" text-neutral-400">{item.motherPhone || "---"}</div>
          <div className="text-neutral-400 text-nowrap">
            <span className="font-semibold">Father : </span>{" "}
            {item.fatherEmail || "---"}
          </div>
          <div className=" text-neutral-400">{item.fatherPhone || "----"}</div>
        </div>
      ),
    },
    {
      label: "Query For",
      accessor: "remarks",
      render: (item) => (
        <div className="max-w-44 text-[13px]">{item.remarks || "---"}</div>
      ),
    },
    {
      label: "Source",
      accessor: "sourceOfInfo",
      render: (item) => (
        <div className="text-[13px]">{item.sourceOfInfo || "---"}</div>
      ),
    },
    {
      label: "Status",
      accessor: "status",
      render: (item) => (
        <div className="flex flex-col gap-2 text-[11px] text-nowrap">
          <button
            onClick={() =>
              navigate(popupNavigation("queriesStatus"), {
                state: { queryId: item.id },
              })
            }
            className="flex items-center gap-1 px-2 p-1 w-fit bg-primary-50 text-primary-600 capitalize font-medium cursor-pointer"
          >
            <span>{item.status || "-----"}</span>
            <FiChevronDown className="text-primary-600 text-sm" />
          </button>

          <Tag
            text="reshare"
            color="success"
            onClick={() => {
              setSelectedQuery(item);
              setShowConfirm(true);
            }}
          />

          {item.assignedCounsellorName ? (
            <div className="px-2 p-1 w-fit bg-success-50 text-primary-600  rounded font-medium">
              Assigned: {item.assignedCounsellorName}
            </div>
          ) : (
            <button
              onClick={() => {
                setSelectedQueryForAssign(item);
                setShowAssign(true);
              }}
              className="flex items-center gap-1 px-2 p-1 w-fit bg-primary-50 text-primary-600 capitalize font-medium cursor-pointer"
            >
              <span>Assign To</span>
              <FiChevronDown className="text-primary-600 text-sm" />
            </button>
          )}
        </div>
      ),
    },
    {
      label: "Action",
      accessor: "action",
      render: (item) => (
        <Tag
          text="View Details"
          size="sm"
          color="warning"
          onClick={() => navigate(`/queries/view-query/${item.id}`)}
        />
      ),
    },
  ];

  return (
    <div className="grid gap-7 bg-white px-6 py-5 rounded-lg">
      <DataTable columns={columns} data={data} isLoading={loading} />

      {showConfirm && (
        <ConfirmationModal
          title="Reshare Query"
          message="Are you sure you want to reshare this query?"
          confirmText="Yes, Reshare"
          cancelText="No"
          confirmColor="bg-success-600"
          onClose={() => {
            setShowConfirm(false);
            setSelectedQuery(null);
          }}
          onConfirm={() => {
            if (selectedQuery) {
              window.open(
                `/queries/queries-form/${selectedQuery.branchCode}/re-share/${selectedQuery.id}`,
                "_blank",
                "noopener,noreferrer",
              );

              setShowConfirm(false);
              setSelectedQuery(null);
            }
          }}
        />
      )}
      {showAssign && selectedQueryForAssign && (
        <AssignEnquiryModal
          queryId={selectedQueryForAssign.id}
          onClose={() => {
            setShowAssign(false);
            setSelectedQueryForAssign(null);
          }}
          onAssigned={() => {
            setShowAssign(false);
            setSelectedQueryForAssign(null);
            onRefresh(); 
          }}
        />
      )}
    </div>
  );
}
